import "../../index.css";
import "./BoldText.css";
const BoldText = ({
  clr = "white",
  children,
  marginClass,
  class_Name
}) => {
  return (
    <p className={`bold-p ${clr && `${clr}`} ${marginClass && marginClass} ${class_Name && class_Name}`}>{children}</p>
  );
};

export default BoldText;